import axios from "axios";

// const config = axios.create({
//     baseURL: "beta-api.tufiado.com/",
//     headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         app: "USERS_APP",
//     },
// });

// const config = axios.create({
//     baseURL: "https://api-dev.tufiado.com/",
//     headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         app: "USERS_APP",
//     },
// }); 

const config = axios.create({
    baseURL: "https://staging-api.tufiado.com",
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        app: "USERS_APP",
    },
});

export default config;
